import type { Attachment } from './attachment.type.ts';
export interface AttachmentExtension extends Attachment {}
export class AttachmentExtension {
  get displayClassification(): string {
    return this.classification || this.assetClassification;
  }

  get displayDescription(): string {
    return this.description || this.assetDescription;
  }
}

const Registration = {
  kind: 'object',
  name: 'attachment',
  features: AttachmentExtension,
};
export default Registration;
